import { PartnersDTO, PartnerFlatDTO } from "../domain/models/dto/PartnersDTO";
import {
    IPartnersFlat,
    PartnersFlatCollection,
} from "../domain/models/Partners";
import { PartnersService } from "../domain/services/PartnersService";
import { PartnersFlatMapper } from "../mappers/PartnersFlatMapper";
import { BaseServiceImpl } from "./BaseServiceImpl";
import { LanguageServiceImpl } from "./LanguageServiceImpl";

export class PartnersServiceImpl
    extends BaseServiceImpl
    implements PartnersService
{
    static _instance: PartnersService;
    private readonly endpoint = "/api/v1/partners";

    private constructor() {
        super();
    }

    static getInstance(): PartnersService {
        if (!PartnersServiceImpl._instance) {
            PartnersServiceImpl._instance = new PartnersServiceImpl();
        }
        return PartnersServiceImpl._instance;
    }

    async getAll(
        currentPage: number,
        currentLimit?: number,
        filtersDTO: PartnersDTO = {} as PartnersDTO
    ): Promise<PartnersFlatCollection> {
        try {
            let url = `${this.endpoint}?page=${currentPage}${
                currentLimit ? `&limit=${currentLimit}` : ""
            }&lang=${
                LanguageServiceImpl.getInstance().currentLang
            }&isActive=true`;

            Object.entries(filtersDTO).forEach(([key, value]) => {
                if (key && value !== null && value !== undefined) {
                    url += `&${key}=${value}`;
                }
            });

            const result = await this.get<PartnersFlatCollection>(url);
            return {
                ...result,
                rows: result.rows.map((dto) =>
                    new PartnersFlatMapper().fromDTO(dto)
                ),
            };
        } catch (err) {
            console.log("Error in PartnersServiceImpl.getAll");
            console.log(err);
        }
    }

    async getById(id: string): Promise<IPartnersFlat | null> {
        try {
            if (!id) return null;

            const dto = await this.get<PartnerFlatDTO>(
                `${this.endpoint}/${id}?lang=${
                    LanguageServiceImpl.getInstance().currentLang
                }`
            );
            return new PartnersFlatMapper().fromDTO(dto);
        } catch (err) {
            console.log("Error in PartnersServiceImpl.getById");
            console.log(err);
            return null;
        }
    }
}

export function partnersServiceFactory(): PartnersService {
    return PartnersServiceImpl.getInstance();
}
